import { Component, OnInit } from "@angular/core";
import { TokenService } from "../../core/tokenManagement/token.service";
import { SharedService } from "../../shared/services/shared.service";
import { takeUntil } from "rxjs/operator/takeUntil";
import { Subject } from "rxjs";
import { Notification } from "../../core/helpers/notification";

@Component({
  selector: "app-api-key-setup",

  templateUrl: "./api-key-setup.component.html",
  styleUrls: ["./api-key-setup.component.css"],
})
export class ApiKeySetupComponent implements OnInit {
  showGenerateKeysModal: boolean;
  secretKey: any = "";

  clientId: string;
  destroy$ = new Subject();

  constructor(
    private tokenService: TokenService,
    private sharedService: SharedService,
    private notificationService: Notification
  ) {}

  ngOnInit(): void {
    this.getSecretKey();
  }

  getSecretKey() {
    this.clientId = this.tokenService.getclientID()["clientID"];
    this.sharedService.getSecretKey(this.clientId).subscribe((res) => {
      this.secretKey = res.secretKey;
    });
  }

  toggleEnvironment() {}

  copySecretKey() {
    (navigator as any).clipboard.writeText(this.secretKey).then(() => {
      this.notificationService.Success("Secret Key copied to clipboard");
    });
  }

  refreshSecretKey() {
    this.clientId = this.tokenService.getclientID();
    this.sharedService.updateUserKey(this.clientId).subscribe((res) => {
      this.getSecretKey();
    });
  }

  copyClientId() {
    (navigator as any).clipboard.writeText(this.clientId).then(() => {
      this.notificationService.Success("Client ID copied to clipboard");
    });
  }

  toggleGenerateKeysModal() {}
}
